import { render, staticRenderFns } from "./view-card.vue?vue&type=template&id=d4daaa94"
import script from "./view-card.vue?vue&type=script&lang=js"
export * from "./view-card.vue?vue&type=script&lang=js"
import style0 from "./view-card.vue?vue&type=style&index=0&id=d4daaa94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports